/**
 * Défintion des types de clients possibles 
 */
export enum ClientTypeEnum {
    WEB = 'WEB',
    MOBILE = 'MOBILE'
}